<template>
  <el-tag class="column-tag-renderer" v-bind="tagProps" effect="dark" size="small">{{ params.value }}</el-tag>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'ColumnTagRenderer',
  data() {
    return {
      tagProps: null
    }
  },
  created() {
    const { params } = this
    this.tagProps = { color: params.color }
  }
})
</script>

<style lang="scss">
.column-tag-renderer{
  border-color:transparent!important;
}

</style>
